<template>
    <div>
        <v-row>
            <v-col>
                <v-tabs v-model="tab" dark class="rounded-lg" dense background-color="primary" active-class="tab-active"
                    slider-color="#ffbc00">
                    <v-tab class="font-weight-black">Banco</v-tab>
                    <v-tab class="font-weight-black">Talonario</v-tab>
                    <v-tab class="font-weight-black">Ingresos y Egresos</v-tab>
                    <v-tab class="font-weight-black">Proveedores</v-tab>
                    <v-tab class="font-weight-black">Promociones</v-tab>
                    <v-tab class="font-weight-black">Moras</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <bancoComp class="py-4"></bancoComp>
                    </v-tab-item>

                    <v-tab-item>
                        <talonarioComp class="py-4"></talonarioComp>
                    </v-tab-item>

                    <v-tab-item>
                        <conceptoFacturacionComp class="py-4"></conceptoFacturacionComp>
                    </v-tab-item>

                    <v-tab-item>
                        <proveedorComp class="py-4"></proveedorComp>
                    </v-tab-item>

                    <v-tab-item>
                        <promocionesComp class="py-4"></promocionesComp>
                    </v-tab-item>

                    <v-tab-item>
                        <moraComp class="py-4"></moraComp>
                    </v-tab-item>

                </v-tabs-items>

            </v-col>
        </v-row>
    </div>
</template>



<script>

import BancoComp from './components/BancoComp.vue'
import TalonarioComp from './components/TalonarioComp.vue'
import ConceptoFacturacionComp from './components/ConceptoFacturacionComp.vue'
import ProveedorComp from './components/ProveedorComp.vue'
import PromocionesComp from './components/PromocionesComp.vue'
import MoraComp from './components/MoraComp.vue'

export default {
    components: {
        bancoComp: BancoComp,
        talonarioComp: TalonarioComp,
        conceptoFacturacionComp: ConceptoFacturacionComp,
        proveedorComp: ProveedorComp,
        promocionesComp: PromocionesComp,
        moraComp: MoraComp
    },

    data() {
        return {
            tab: 0,
        }
    },
}

</script>